module.exports = __webpack_public_path__ + "img/hafra_yes.e8401a25.png";